<template>
  <div class="introduction">
    <div class="introduction-container">
      <div class="introduction-container-msg">
        <p class="introduction-container-msg-title">大赛简介</p>
        <p class="introduction-container-msg-content">
          我国私募市场逐渐成熟，管理规模逐渐增长。截至2021年2月，私募证券投资基金管理人8934家，存续私募证券投资基金产品57539只，管理规模达到4.4万亿元。众多优质的私募基金管理人破土而出，亟需一个展示自我的平台。</p>
        <p class="introduction-container-msg-content">
          此次私募实盘大赛是由申万宏源证券与深圳希施玛数据科技有限公司、深圳丽海弘金科技有限公司联合主办，深圳排排网投资管理有限公司承办，重磅推出的全国性私募实盘大赛。此次私募大赛旨在为私募管理机构提供高端的自我展现与高效的投资交流平台，助力私募管理人提升投资能力、拓宽资金募集渠道，同时促进行业内资源的整合，为市场挖掘优质的私募基金管理人。</p>
      </div>
      <div class="introduction-container-highlights">
        <div class="title">大赛亮点</div>
        <div class="introduction-container-highlights-content">
          <div class="introduction-container-highlights-content-left">
            大赛主协办方凭借专业平台的传播资源，协同主流财经媒体和自媒体，为大赛提供优质的宣传平台。大赛周期较长，将持续高频输出大赛内容，提高大赛的影响力，对优质的私募管理人进行采访，在多平台宣传推送，提高市场对私募管理人的关注度。
          </div> 
          <div class="introduction-container-highlights-content-right">
            <p>1、申万宏源证券、深圳希施玛、深圳丽海弘金和私募排排网拥有众多的机构投资者资源，在私募大赛进程中举办机构对接会，邀约合格机构投资者来到现场，和参赛私募基金管理人一对一现场交流。</p>
            <p>2、定期邀请申万宏源证券研究所分析师参与线上线下交流，为私募提供投研服务。</p>
            <p>3、私募排排网每季度邀请优质参赛私募线上路演，与私募排排网110万高净值客户面对面交流。</p>
          </div>
        </div>
      </div>
      <div class="introduction-container-committee">
        <div class="title">大赛组委会</div>
        <p class="introduction-container-committee-tips">
          大赛组委会由申万宏源证券、深圳希施玛数据、丽海弘金和私募排排网共同组成。大赛主办方为申万宏源证券、深圳希施玛数据、丽<br/>海弘金；承办方为私募排排网。
        </p> 
        <div class="introduction-container-committee-content">
          <div class="introduction-container-committee-content-item">
            <p class="title">申万宏源证券</p> 
            <div class="content">
              <p>联系人：张明玉、程莎莎</p> 
              <p>TEL：021-33388476、021-33389692</p> 
              <p>CP：15221672493、18801785132</p> 
              <p>电子邮件：zhangmy@swhysc.com、chengshasha@swhysc.com</p>
            </div>
          </div> 
          <div class="introduction-container-committee-content-item">
            <p class="title">深圳希施玛数据</p> 
            <div class="content">
              <p>联系人：赵学平、欧阳林</p> 
              <p>TEL：0755-86708915</p> 
              <p>CP：13008831037、18617067145</p> 
              <p>电子邮件：xueping.zhao@csmar.com、yanglin.ou@csmar.com</p>
            </div>
          </div> 
          <div class="introduction-container-committee-content-item">
            <p class="title">丽海弘金</p> 
            <div  class="content">
              <p>联系人：凌楚蕃</p> 
              <p>CP：15521029949</p> 
              <p>电子邮件：lingchufan@hongkingsystem.cn</p>
            </div>
          </div> 
          <div class="introduction-container-committee-content-item">
            <p class="title">私募排排网</p> 
            <div class="content">
              <p>联系人：李女士</p> 
              <p>CP：15218742926</p> 
              <p>电子邮件：lichao@simuwang.com</p>
            </div>
          </div>
        </div>
      </div>
      <div class="introduction-container-schedule">
        <div class="title">赛程安排</div>
        <div class="introduction-container-schedule-content">
          <div class="introduction-container-schedule-content-top">
            <div class="left">
              <p class="title">大赛启动</p>
              <p class="content">2021年6月—报名通道开启。</p>
              <p class="content">2021年6月8日—大赛启动仪式。</p>
            </div>
            <div class="middle">
              <p class="title">私募大赛、线下沙龙</p>
              <p class="content">2021年6月1日-2022年5月31日（比赛期间均可报名、2022年5月18日后报名的不参与评选）。</p>
            </div>
            <div class="right">
              <p  class="title">私募大赛颁奖</p>
              <p class="content">2022年6月-大赛结束、颁奖。</p>
            </div>
          </div> 
          <div class="introduction-container-schedule-content-bottom"></div>
        </div>
      </div>
      <div class="introduction-container-apply">
        <div  class="title">报名渠道</div> 
        <div  class="introduction-container-apply-content">
          <div  class="text">
            <p >1、申万宏源证券有限公司官网报名入口链接 https://www.swhysc.com/swhysc/</p> 
            <p >2、申万宏源大赢家APP和“申万宏源证券”微信公众号、“申万宏源证券”微博报名通道</p> 
            <p >3、通过希施玛公司官网、微信公众号、红楹金融终端、红楹金玛终端大赛宣传页面访问进入以上报名通道，官网链接：http://www.csmar.com/</p> 
            <p >4、丽海弘金官网报名入口链接：https://www.hongkingsystem.cn/</p> 
            <p >5、私募排排网网页报名链接：https://www.simuwang.com/</p>
          </div> 
          <div class="item-list">
            <div class="item">
              <p>申万宏源证券官网<br >报名入口</p> 
              <a href="https://www.swhysc.com/swhysc/" target="_blank">
                <span class="btn">点击了解<img width="14" src="../assets/img/arrow-white.png"></span>
              </a>
            </div>
            <div class="item">
              <p>丽海弘金官网<br >报名入口</p>
              <a href="https://www.hongkingsystem.cn/" target="_blank">
                <span class="btn">点击了解<img width="14" src="../assets/img/arrow-white.png"></span>
              </a>
            </div>
            <div class="item">
              <p>深圳希施玛数据官网<br >报名入口</p>
              <a href="http://www.csmar.com/" target="_blank">
                <span class="btn">点击了解<img width="14" src="../assets/img/arrow-white.png"></span>
              </a>
            </div>
            <div  class="item">
              <p>私募排排网官网<br >报名入口</p>
              <a href="https://www.simuwang.com/" target="_blank">
                <span class="btn">点击了解<img width="14" src="../assets/img/arrow-white.png"></span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>
<style lang="less" scoped>
  .introduction {
    width: 100%;
    margin: 0 auto;
    padding-top: 60px;
    background: url('../assets/img/introduction-bg.png') no-repeat center / 100% 100%;
    padding-bottom: 78px;
  }
  .introduction-container {
    width: 1200px;
    margin: 0 auto;
    & > div > .title {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      height: 61px;
      background: url('../assets/img/title-bg.png') no-repeat center / 100% 100%;
      font-size: 30px;
      font-weight: bold;
      color: #fff;
    }
    &-msg {
      position: relative;
      width: 100%;
      height: 379px;
      background: url('../assets/img/box-bg.png') no-repeat center / 100% 100%;
      padding: 0 42px;
      padding-top: 70px;
      &-title {
        position: absolute;
        top: 15px;
        left: 0;
        width: 100%;
        color: #fff;
        font-size: 32px;
        font-weight: bold;
        text-align: center;
        margin: 0;
      }
      &-content {
        margin-top: 48px;
        font-size: 18px;
        color: #fff;
        text-align: center;
        line-height: 30px;
      }
    }
    &-highlights {
      padding-top: 80px;
      &-content {
        padding-top: 35px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        & > div {
          width: 580px;
          height: 550px;
          font-size: 18px;
          color: #fff;
          line-height: 30px;
          padding: 0 48px;
          padding-top: 257px;
        }
        &-left {
          background: url('../assets/img/highlights-bg1.png') no-repeat center / 100% 100%;
        }
        &-right {
          background: url('../assets/img/highlights-bg2.png') no-repeat center / 100% 100%;
        }
      }
    }
    &-committee {
      padding-top: 100px;
      &-tips {
        padding: 0 48px;
        padding-top: 36px;
        font-size: 18px;
        color: #fff;
        line-height: 30px;
        text-align: center;
      }
      &-content {
        padding-top: 30px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        &-item {
          width: 580px;
          height: 240px;
          background: url('../assets/img/committee-bg.png') no-repeat center / 100% 100%;
          margin-top: 30px;
          padding-left: 28px;
          .title {
            line-height: 70px;
            font-size: 22px;
            color: #020D6B;
            font-weight: bold;
          }
          .content {
            padding-top: 20px;
            font-size: 16px;
            color: #fff;
            line-height: 30px;
            font-weight: 400;
          }
        }
      }
    }
    &-schedule {
      padding-top: 106px;
      &-content {
        padding-top: 116px;
        &-top {
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          > div {
            -webkit-box-flex: 1;
            -ms-flex: 1;
            flex: 1;
            .title {
              position: relative;
              font-size: 22px;
              color: #44E0FE;
              font-weight: bold;
              padding-bottom: 24px;
              &::after {
                position: absolute;
                top: 5px;
                right: -57px;
                content: '';
                display: block;
                width: 37px;
                height: 12px;
                background: url('../assets/img/arrow.png') no-repeat center / 100%  100%;
              }
            }
            .content {
              font-size: 16px;
              color: #fff;
              line-height: 30px;
            }
          }
          .left {
            width: 280px;
            -webkit-box-flex: 0;
            -ms-flex: none;
            flex: none;
            margin-right: 135px;
          }
          .middle {
            width: 420px;
            -webkit-box-flex: 0;
            -ms-flex: none;
            flex: none;
            margin-right: 72px;
            .title::after{
              right: -37px;
            }
          }
          .right {
            .title::after{
              background: none;
            }
          }
        }
        &-bottom {
          width: 100%;
          height: 271px;
          background: url('../assets/img/schedule.png') no-repeat center / 100% 100%;
        }
      }
    }
    &-apply {
      padding-top: 107px;
      &-content {
        padding-top: 67px;
        .text {
          font-size: 17px;
          text-align: center;
          line-height: 24px;
          color: #fff;
        }
        .item-list {
          padding-top: 37px;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-pack: justify;
          -ms-flex-pack: justify;
          justify-content: space-between;
          .item {
            width: 286px;
            height: 210px;
            background: url('../assets/img/apply-item-bg.png') no-repeat center / 100% 100%;
            padding-top: 43px;
            color: #fff;
            p {
              font-size: 22px;
              font-weight: bold;
              line-height: 30px;
              text-align: center;
            }
            .btn {
              display: -webkit-box;
              display: -ms-flexbox;
              display: flex;
              -webkit-box-pack: center;
              -ms-flex-pack: center;
              justify-content: center;
              -webkit-box-align: center;
              -ms-flex-align: center;
              align-items: center;
              margin: 0 auto;
              margin-top: 32px;
              width: 183px;
              height: 50px;
              font-size: 16px;
              border: 1px solid #F9F6D6;
              border-radius: 4px;
              cursor: pointer;
              color: #fff;
              img {
                width: 14px;
                margin-left: 12px;
              }
            }
          }
        }
      }
    }
  }
</style>